/*
  Shopify Inbox chat launcher (2026-10-14). The launcher (<shopify-chat>, fixed bottom right, top z-index) covered
  the cart drawer's subtotal and checkout button on phones and the customizer's controls on desktop. This hides it
  (assets/sparko-custom.css, "Shopify Inbox chat launcher") while:
    - the cart drawer is open: the theme's modal store announces it with cart-will-open / cart-is-closed;
    - the customizer's phone sheet is open: the customizer puts .spk-lock on <html> (CSS only, nothing here);
    - the customizer (.sparko-pdp-app) reaches the bottom band of the screen, where the launcher sits;
    - an embedded arcade game (.sparko-page-embed__content, 2026-10-19) reaches that band. On a phone the games fill
      the screen and the launcher sat on Sudoku's number pad and the bottom of the Nebula Stack well.
    - a Load more pill (.sparko-loadmore, collections and search, 2026-10-24) reaches that band. On a phone
      the launcher landed on the pill's right half as the shopper scrolled down to it;
    - the phone filter sheet is open: sparko-collection-grid puts .sparko-chat-off--sheet on <html> (CSS only);
    - any drawer or modal is showing: the menu drawer, the cart and other theme drawers, any modal (2026-10-29).
  Everywhere else the launcher is unchanged.
*/
(function () {
  const root = document.documentElement;
  const BAND = 140; // px at the bottom of the screen the launcher occupies, with room to spare

  document.body.addEventListener('cart-will-open', () => root.classList.add('sparko-chat-off--cart'));
  document.body.addEventListener('cart-is-closed', () => root.classList.remove('sparko-chat-off--cart'));

  // Any drawer or modal showing (2026-10-29). The launcher sat on top of the
  // phone menu drawer, which is an Alpine x-show in the header and announces
  // nothing. The theme's own modals (cart and other drawers, the modal, quick
  // buy, the promo) are Alpine x-show containers with ids starting "modals-",
  // teleported to <body> after load. x-show writes `display: none` into each
  // one's style attribute, so watching those attributes is enough: no event
  // from any of them is needed, and a new kind of drawer is covered as long as
  // it keeps the theme's id convention.
  const OVERLAY = '[id^="modals-"], .sparko-header__drawer';
  const watched = new WeakSet();
  const overlayCheck = () => {
    const open = [...document.querySelectorAll(OVERLAY)].some((el) => getComputedStyle(el).display !== 'none');
    root.classList.toggle('sparko-chat-off--overlay', open);
  };
  const styleObserver = new MutationObserver(overlayCheck);
  const watchOverlays = () => {
    document.querySelectorAll(OVERLAY).forEach((el) => {
      if (watched.has(el)) return;
      watched.add(el);
      styleObserver.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
    });
    overlayCheck();
  };
  watchOverlays();
  // The modal containers arrive by teleport, straight into <body>.
  new MutationObserver(watchOverlays).observe(document.body, { childList: true });

  if (!('IntersectionObserver' in window)) return;

  // Toggles `cls` on <html> while any of `els` overlaps the bottom band.
  const hideOver = (els, cls) => {
    if (!els.length) return;
    const showing = new Set();
    let io = null;
    const watch = () => {
      if (io) io.disconnect();
      showing.clear();
      io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => (e.isIntersecting ? showing.add(e.target) : showing.delete(e.target)));
          root.classList.toggle(cls, showing.size > 0);
        },
        { rootMargin: `-${Math.max(0, window.innerHeight - BAND)}px 0px 0px 0px` }
      );
      els.forEach((el) => io.observe(el));
    };
    watch();
    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(watch, 200);
    });
  };

  hideOver([...document.querySelectorAll('.sparko-pdp-app')], 'sparko-chat-off--customizer');
  hideOver([...document.querySelectorAll('.sparko-page-embed__content')], 'sparko-chat-off--game');
  hideOver([...document.querySelectorAll('.sparko-loadmore')], 'sparko-chat-off--more');
})();
